import { render } from "./SenderMessages.vue?vue&type=template&id=5ad8f246&scoped=true"
import script from "./SenderMessages.vue?vue&type=script&lang=js"
export * from "./SenderMessages.vue?vue&type=script&lang=js"

import "./SenderMessages.vue?vue&type=style&index=0&id=5ad8f246&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad8f246"]])

export default __exports__